// extracted by mini-css-extract-plugin
export var close = "video-popup-module--close--1580e";
export var email = "video-popup-module--email--3160f";
export var form = "video-popup-module--form--46dc9";
export var link = "video-popup-module--link--24744";
export var modal = "video-popup-module--modal--61546";
export var modalContent = "video-popup-module--modalContent--ffd1b";
export var popup_container = "video-popup-module--popup_container--5005f";
export var popup_content = "video-popup-module--popup_content--47c10";
export var semiBold = "video-popup-module--semiBold--42a17";
export var slideDown = "video-popup-module--slideDown--cd04f";
export var submit_large = "video-popup-module--submit_large--ebfbe";
export var submit_small = "video-popup-module--submit_small--38b69";
export var text_container = "video-popup-module--text_container--efadf";
export var video = "video-popup-module--video--8b4ab";